import { EN_KO, Cookies, TAO_KOE } from '../libs';
import Download from './download';

class DownloadPopup {
	constructor( popupEl ) {
		this.popupEl = popupEl;
		this.formEl = popupEl.querySelector( '#tao_presse_download_form' );
		this.triggerEl = null;

		// Download Button Click Event.
		document.addEventListener( 'click', ( ev ) => {
			const targetEl = ev.target.closest( '.download-trigger,.download-trigger-single' );
			if ( targetEl ) {
				ev.preventDefault();

				const isSingle = targetEl.classList.contains( 'download-trigger-single' );
				if ( isSingle || Download.getCheckedInputEls().length > 0 ) {
					this.triggerEl = targetEl;
					EN_KO.functions.open_popup( popupEl );
				} else {
					// eslint-disable-next-line no-alert
					window.alert( 'Bitte wählen Sie Bilder für den Download aus!' );
				}
			}
		} );

		// Setup Form.
		this.popupEl.addEventListener( 'popup_opened.sl', () => this.setupForm() );
		this.popupEl.addEventListener( 'popup_closed.sl', () => this.resetForm() );

		// Submit Form.
		this.formEl.addEventListener( 'submit', ( ev ) => this.onSubmit( ev ) );
		this.formEl.addEventListener( 'change', ( ev ) => {
			if ( ev.target.matches( '.tao_presse_agb' ) ) {
				EN_KO.functions.toggleDisplay( popupEl.querySelector( '.fail_sent' ), false );
			}
		} );

		// Reset all Elements after successful Downloadstart.
		setInterval( () => {
			if ( Cookies.get( 'tao_presse_reset' ) ) {
				Download.forEachInstance( ( instance ) => {
					instance.unselectAll( true );
				} );

				Cookies.set( 'tao_presse_reset', '' );
				EN_KO.functions.close_popup( popupEl );
			}
		}, 1000 );
	}

	setupForm() {
		const popupEl = this.popupEl;
		const formEl = this.formEl;
		const triggerEl = this.triggerEl;

		const isSingle = triggerEl && triggerEl.classList.contains( 'download-trigger-single' );
		if ( isSingle ) {
			// Setup Form Action.
			[ formEl.method, formEl.action ] = [ 'GET', '/dispatch/download/single/' ];

			// Setup Inputs.
			popupEl.querySelectorAll( '.download_inputs' ).forEach( ( inputContainerEl ) => {
				const download = triggerEl.getAttribute( 'data-download' );
				const postID = triggerEl.getAttribute( 'data-post-id' );

				inputContainerEl.innerHTML = `
					<input type="hidden" name="download" value="${ download }" />
					<input type="hidden" name="post_id" value="${ postID }" />
				`;
			} );
		} else {
			// Setup Form Action.
			[ formEl.method, formEl.action ] = [ 'POST', '/dispatch/download/all/' ];

			// Setup Inputs.
			const inputEls = Array.from( Download.getCheckedInputEls() ).map( ( inputEl ) => {
				const clonedEl = inputEl.cloneNode( true );
				clonedEl.removeAttribute( 'id' );
				return clonedEl;
			} );

			popupEl.querySelectorAll( '.download_inputs' ).forEach( ( inputContainerEl ) => {
				inputContainerEl.replaceChildren( ...inputEls );
			} );
		}
	}

	resetForm() {
		this.triggerEl = null;
		this.formEl.querySelectorAll( '.download_inputs' ).forEach( ( inputContainerEl ) => inputContainerEl.innerHTML = '' );
		this.formEl.querySelectorAll( '.tao_presse_agb' ).forEach( ( checkboxEl ) => checkboxEl.checked = false );
		this.formEl.querySelectorAll( 'button[type="submit"]' ).forEach( ( buttonEl ) => buttonEl.classList.remove( 'en_button--loading' ) );
	}

	onSubmit( ev ) {
		const formEl = ev.target;
		const buttonEl = formEl.querySelector( 'button[type="submit"]' );
		if ( buttonEl.classList.contains( 'en_button--loading' ) ) {
			ev.preventDefault();
			return false;
		}

		// Check for AGB Checked.
		const agbInputEl = formEl.querySelector( '.tao_presse_agb' );
		if ( ! agbInputEl.checked ) {
			// Show Error Message.
			ev.preventDefault();
			EN_KO.functions.toggleDisplay( formEl.querySelector( '.fail_sent' ), true );
			return false;
		}

		// Success - Show Loading Icon.
		buttonEl.classList.add( 'en_button--loading' );

		// Remove unload Listener.
		Download.removeUnloadListener();
		return true;
	}
}

DownloadPopup.init = function( scopeEl = document ) {
	const popupEl = scopeEl.getElementById( 'popup_pressdownload' );
	if ( ! popupEl ) {
		return;
	}

	popupEl.KOE_DOWNLOAD_POPUP ??= new DownloadPopup( popupEl );
};

TAO_KOE.ready( 'download-popup.js', () => DownloadPopup.init() );

// Expose.
Download.Popup = DownloadPopup;

// Export.
export default DownloadPopup;
